/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carousel__NextInputs */

const en_carousel__next = /** @type {(inputs: Carousel__NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Carousel__NextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const carousel__next = /** @type {((inputs?: Carousel__NextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carousel__NextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_carousel__next(inputs)
});